import "./style.css";

import { NavLink } from "react-router-dom";
const Header = () => {
  return (
    <header className="header">
      <div className="header__wrapper">
        <h1 className="header__title">
          <strong>
            Hello, I'm <em>Leonid </em>
          </strong>
          <br />
          an AI Automation Engineer
        </h1>
        <div className="header__text">
          <p>
            n8n · JavaScript · Python — I build the pipelines that move data
            between ERP, CRM and marketplace systems, and the AI steps that make
            decisions inside them. <br />
            350+ production workflows and 5+ self-hosted Python micro-services,
            running across 11+ marketplaces, Amazon SP-API among them. A frontend background
            means I can take a system from the data pipeline all the way to the
            interface someone actually uses.
          </p>
        </div>
        <NavLink to="/projects" className="btn">
          Projects
        </NavLink>
      </div>
    </header>
  );
};

export default Header;
